const structuredData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  url: 'https://www.circus-strongman.com',
  name: 'Circus Strongman Experience',
  description: 'Number 1 destination for strongman in Greece',
  image:
    'https://res.cloudinary.com/ionpetro/image/upload/v1629745325/Screenshot_2021-08-23_at_10.01.34_PM_ljmttl.png',
  address: 'Dimitrakopoulou 18, Athens 111 41',
  telephone: '6984102701',
};

export default structuredData;
